const translationActionTypes = {
  RESET_STATE: 'RESET_STATE',
  SET_DATA: 'SET_DATA',
  LOAD_RESOURCES: 'RESOURCES_LOADING',
  RESOURCES_LOADED: 'RESOURCES_LOADED',
  RESOURCE_LOAD_FAIILED: 'RESOURCE_LOADING_FAILED',
};

export { translationActionTypes as default };
